module.exports = __webpack_public_path__ + "img/1.2c987fe2.png";